import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrPanelComponent } from './pr-panel/pr-panel.component';
import { PrPanelHeaderComponent } from './pr-panel-header/pr-panel-header.component';
import { PrPanelBodyComponent } from './pr-panel-body/pr-panel-body.component';
import { MatIconModule } from '@angular/material/icon';
import { PrPanelFooterComponent } from './pr-panel-footer/pr-panel-footer.component';
import { PrSubPanelComponent } from './pr-sub-panel/pr-sub-panel.component';
import { PrLoaderModule } from '../pr-loader/pr-loader.module';

@NgModule({
  imports: [CommonModule, MatIconModule, PrLoaderModule],
  declarations: [
    PrPanelComponent,
    PrPanelHeaderComponent,
    PrPanelBodyComponent,
    PrPanelFooterComponent,
    PrSubPanelComponent,
  ],
  exports: [
    PrPanelComponent,
    PrPanelHeaderComponent,
    PrPanelBodyComponent,
    PrPanelFooterComponent,
    PrSubPanelComponent,
  ],
})
export class PrPanelModule {}
